<template>
  <div class="finance-page main-wrapper">
    <div class="finance-page__inner px-2 px-md-3 pt-2">
      <h3 class="finance-page__title">
        {{ $t('banking.bank_info') }}
      </h3>
      <div
        class="finance-alert"
        v-if="error"
      >
        <span class="mx-auto">{{ typeof error === 'string' ? error : (error && error.message) || '' }}</span>
      </div>

      <div class="finance-panel">
        <form>
          <div class="mt-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label
                    class="finance-label"
                    for="banking-name"
                  >{{ $t('banking.bank_username') }}</label>
                  <input
                    id="banking-name"
                    type="text"
                    class="form-control finance-input"
                    v-model="account.name"
                  >
                  <span class="text-danger">{{
                    errors.name
                  }}</span>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label
                    class="finance-label"
                    for="banking-number"
                  >{{ $t('banking.bank_number') }}</label>
                  <input
                    id="banking-number"
                    type="number"
                    class="form-control finance-input"
                    v-model="account.account_number"
                  >
                  <span class="text-danger">{{
                    errors.number
                  }}</span>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label
                        class="finance-label"
                        for="input-username"
                      >{{ $t('banking.bank_type') }}</label>
                      <AccountSelect
                        :data="account"
                        field="type"
                        :accounts="accounts"
                      />
                      <span class="text-danger">{{
                        errors.account
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-12 mt-2 mb-0">
                <button
                  type="button"
                  class="btn finance-btn-primary"
                  @click="updateBankInfo()"
                >
                  <div v-if="!isConfirm">
                    {{ $t('banking.submit') }}
                  </div>
                  <Loading
                    color="#fff"
                    v-if="isConfirm"
                    size="24"
                    class="px-4 py-0"
                  />
                </button>
              </div>
              <div class="col-12 mt-3">
                <div class="finance-note-box">
                  <div class="finance-note-box__title">{{ $t('banking.note') }}</div>
                  <div class="finance-note-box__body">
                    {{ $t('banking.note_content') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';


export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      error: null,
      accounts: [
        {
          name: 'The Siam Commercial Bank ( SCB Bank )',
          id: 'The Siam Commercial Bank ( SCB Bank )',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'Krungthai',
          id: 'Krungthai',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },

        {
          name: 'Yoma Bank',
          id: 'Yoma Bank',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ Mobile Banking',
          id: 'KBZ Mobile Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kbz.png',
        },
        {
          name: 'Wave pay',
          id: 'Wave pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
        {
          name: 'CB Pay',
          id: 'CB Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/cb_pay.png',
        },
        {
          name: 'CB Banking',
          id: 'CB Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/cbbank.png',
        },
        {
          name: 'AYA Pay',
          id: 'AYA Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/ayapay.png',
        },
        {
          name: 'AYA Banking',
          id: 'AYA Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },

      ],
      account: [],
      imageUploader: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    async fetchBankInfo() {
      try {
        const res = await axios.get('/user_bank',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        this.account = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions(['fetchUser']),
    async updateBankInfo() {
      try {
        this.error = null;
        if (!this.account.type) {
          this.error = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.account.account_number) {
          this.error = this.$store.state.language === 'en'
            ? 'Please enter account number'
            : 'အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
          return false;
        }
        if (!this.account.name) {
          this.error = this.$store.state.language === 'en'
            ? 'Please enter bank username'
            : 'Please enter bank username';
          return false;
        }

        this.isConfirm = true;

        await axios.put('/user_bank', this.account, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.error = null;
        Dialog.alert({
          message: this.$store.state.language === 'en'
            ? 'Bank account information updated successfully'
            : 'ဘဏ်အကောင့်ထည့်သွင်းခြင်းအောင်မြင်ပါသည်။',
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        }).then(() => {
          this.$router.push('/withdraw');
        });
        this.isConfirm = false;
      } catch (error) {
        // this.error = error.response.data
        Dialog.alert({
          message: error.response.data,
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        })
        this.isConfirm = false;
      }
      return true;
    },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    await this.fetchBankInfo()
    const authUser = await this.fetchUser();
    // this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push('/auth/login');
    }
  },
};
</script>
<style scoped>
.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 5px;
  background: #e9ecef;
  justify-content: center;
}

.custom-file {
  height: auto;
}
</style>
